module.exports = __webpack_public_path__ + "fonts/IvarDisplay-Italic.woff2";